export const CheckCircleIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '40'}
    height={props?.height || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.6664 18.4671V20.0004C36.6643 23.5945 35.5005 27.0916 33.3486 29.9701C31.1966 32.8487 28.1718 34.9546 24.7253 35.9736C21.2787 36.9926 17.5951 36.8703 14.2238 35.6247C10.8525 34.3792 7.9741 32.0773 6.01794 29.0622C4.06179 26.0472 3.13266 22.4805 3.36914 18.8943C3.60561 15.308 4.99502 11.8943 7.33014 9.16221C9.66526 6.43012 12.821 4.52606 16.3267 3.734C19.8323 2.94194 23.5001 3.30432 26.783 4.76709M36.6664 6.66709L19.9997 23.3504L14.9997 18.3504"
      stroke={props?.color || '#039855'}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
